var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityAssurance2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2751.16 2757.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#bdd0fb;}.cls-10,.cls-27,.cls-29,.cls-4,.cls-9{fill:#fff;}.cls-4{mix-blend-mode:soft-light;}.cls-5{fill:#91b3fa;}.cls-6{fill:#2b69b3;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#7d97f4;}.cls-10,.cls-11{opacity:0.6;}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:#18174a;}.cls-27{opacity:0.37;}.cls-28{fill:url(#linear-gradient-17);}.cls-29{opacity:0.27;}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#linear-gradient-21);}.cls-34{fill:url(#linear-gradient-22);}.cls-35{fill:url(#linear-gradient-23);}.cls-36{fill:url(#linear-gradient-24);}.cls-37{fill:url(#linear-gradient-25);}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-28);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3106.72,
    y1: 3568.4,
    x2: 662.13,
    y2: 532.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 479.53,
    y1: 2340.93,
    x2: 698.62,
    y2: 1494.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1292.29,
    y1: 485.94,
    x2: 574.79,
    y2: 1710.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1423.64,
    y1: 562.9,
    x2: 706.15,
    y2: 1787.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1534.09,
    y1: 864.78,
    x2: 590.01,
    y2: 2181.09,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1686.35,
    y1: 716.82,
    x2: 968.85,
    y2: 1941.42,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1703.18,
    y1: 1017.2,
    x2: 985.68,
    y2: 2241.81,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1399.53,
    y1: 177.3,
    x2: 551.22,
    y2: 1110.45,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1451.1,
    y1: 224.19,
    x2: 602.78,
    y2: 1157.33,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1538.78,
    y1: 303.91,
    x2: 690.46,
    y2: 1237.06,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1655.15,
    y1: 409.71,
    x2: 806.83,
    y2: 1342.85,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1749.33,
    y1: 495.34,
    x2: 901.02,
    y2: 1428.48,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1830.73,
    y1: 569.34,
    x2: 982.4,
    y2: 1502.5,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1943.28,
    y1: 671.67,
    x2: 1094.96,
    y2: 1604.82,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2023.15,
    y1: 744.29,
    x2: 1174.84,
    y2: 1677.44,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2119.47,
    y1: 831.86,
    x2: 1271.13,
    y2: 1765.03,
    gradientTransform: "translate(36.86 -13.89) rotate(-1.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2049.49,
    y1: 2292,
    x2: 1491.84,
    y2: 2839.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1648.7,
    y1: 1596.34,
    x2: 1491.13,
    y2: 1596.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 2157.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -291.13,
    y1: 2654.03,
    x2: -239.4,
    y2: 2654.03,
    gradientTransform: "translate(738.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -477.56,
    y1: 2651.38,
    x2: -432.9,
    y2: 2651.38,
    gradientTransform: "translate(738.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1966.52,
    y1: 3011.81,
    x2: 1906.77,
    y2: 2603.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 2157.95, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2180.29,
    y1: 2980.52,
    x2: 2120.54,
    y2: 2572.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 2157.95, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -656.46,
    y1: 1672.29,
    x2: -311.01,
    y2: 1672.29,
    gradientTransform: "translate(738.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -335.84,
    y1: 1643.67,
    x2: -231.65,
    y2: 1643.67,
    gradientTransform: "translate(738.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1121.27,
    y1: 1956.7,
    x2: 1225.47,
    y2: 1956.7,
    gradientTransform: "matrix(-0.85, -0.53, -0.53, 0.85, 2649.4, 523.42)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -393.7,
    y1: 1338.24,
    x2: -261.47,
    y2: 1338.24,
    gradientTransform: "translate(738.48)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -4990.96,
    y1: -989.08,
    x2: -5040.37,
    y2: -1152.05,
    gradientTransform: "translate(5543.68 1810.96) rotate(-5.84)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -5041.47,
    y1: -989.84,
    x2: -5085.93,
    y2: -1136.46,
    gradientTransform: "translate(5543.68 1810.96) rotate(-5.84)",
    xlinkHref: "#linear-gradient-18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2434.2,2371.11c-56.15,59.11-109.28,97.23-151.26,127.35-493.43,354-1077.28,250.84-1201.37,225.64-183.24-37.22-537.43-109.16-793.5-410.3C-99.35,1858.21-39,1140.43,261.49,666.61c55-86.67,345.32-567.7,935.46-644.84,357.15-46.69,773.47,47.47,1075,300.06C2904.76,852,2859.71,1923.14,2434.2,2371.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283,21C278.17,6.14,295.5-6.08,308,3.26,435.26,98.15,748.2,390,743.59,962.77c-5.79,718.61,171.25,960.45,373,1097.32,0,0-260.83-45.5-449.46-289.88C204,1170.19,368.64,285.37,283,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M395.63,232.44c23.35,77.28,45.17,155,64.11,233.34q29,117.4,50.81,236.31c14.18,79.28,26.87,158.81,36.17,238.77,9.65,79.91,15.87,160.14,21.82,240.72,6.4,80.49,12.4,161.62,26.71,242.39,14.21,80.6,38.28,160.81,76.28,234.24,9.49,18.3,19.36,36.5,30.2,53.93,10.51,17.64,21.82,34.82,33.42,51.8a879.77,879.77,0,0,0,77,96.46c56.07,60.45,121.31,112.31,191.48,154.5a15.6,15.6,0,0,0,16.47-26.5l0,0c-16.77-10.75-33.41-21.67-49.5-33.3-8.13-5.69-16-11.72-24-17.61-7.75-6.18-15.74-12.06-23.29-18.47a822,822,0,0,1-86.08-81.63c-53.54-58.17-98.67-124.64-135.1-194.72a786.89,786.89,0,0,1-45.35-109.33,893,893,0,0,1-29-115.28c-14.5-78.32-21.09-158.57-28.07-239S585,1017.76,574,937.4q-8.07-60.28-18.31-120.24c-3.29-20-7-39.93-10.62-59.86q-5.76-29.85-11.89-59.61-24.87-119-57-236.19c-21.83-78-45.72-155.34-72.54-231.65a4.19,4.19,0,0,0-8,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.42,2237.43c-6.8,28-40,39.93-63.27,23-128.59-93.35-468.28-390.17-498.14-937.9C92.79,860,35.16,611.59,1.19,500.64-6,477.17,21,458.18,40.66,472.79,258.17,634,925.73,1223.4,679.42,2237.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M640.68,2241.91a12.09,12.09,0,0,1-1.8,1.22,11.23,11.23,0,0,1-15.26-4.44c-3.39-6.17-339.55-624.37-403.67-1265.91a11.25,11.25,0,1,1,22.38-2.23C306,1607.42,640,2221.73,643.33,2227.86A11.26,11.26,0,0,1,640.68,2241.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M700.51,359.76h1620.8A167.92,167.92,0,0,1,2489,519.14L2586.46,2514a123.82,123.82,0,0,1-121.41,130.1L607.41,2677.85a117.54,117.54,0,0,1-119.68-117.52l22.19-2010C509.92,445.09,595.25,359.76,700.51,359.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M878.91,2637.63h-.06L671,2634.94c-69.35-.9-125.77-58.06-125.77-127.41V2193.7a4.16,4.16,0,0,1,8.32,0v313.83c0,64.82,52.73,118.25,117.56,119.09L879,2629.31a4.16,4.16,0,0,1-.05,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M549.38,2100.65a4.16,4.16,0,0,1-4.16-4.16v-50.82a4.16,4.16,0,0,1,8.32,0v50.82A4.16,4.16,0,0,1,549.38,2100.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M705.5,340.71c221.33,30,982.45,122.85,1611.73,74.54a51.2,51.2,0,0,1,55.13,48.28l103.25,2005.33a58.9,58.9,0,0,1-55.34,61.95c-264.66,15.67-1354.63,76.21-1743.4,35.49a46.67,46.67,0,0,1-41.77-46.19l7.61-2124.18A55.36,55.36,0,0,1,705.5,340.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M729.21,401.94c213,28.88,945.45,118.22,1551,71.73a49.27,49.27,0,0,1,53.06,46.47l98.53,1916.44a56.69,56.69,0,0,1-53.26,59.62c-254.7,15.08-1303.62,73.34-1677.75,34.16a44.91,44.91,0,0,1-40.19-44.45l8.15-2030.83A53.28,53.28,0,0,1,729.21,401.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022.11,1207.16h-.36l-140.51-1.35c-19.45-.19-35.5-13.52-37.33-31L831.55,1056.9a24.4,24.4,0,0,1,5.77-18.35A29.64,29.64,0,0,1,858,1028.38h0c11.83-.81,28.48-2.22,46.11-3.73,37.17-3.16,83.42-7.1,109.42-7.43h.56c17.91,0,33.32,10.88,37.58,26.61,7.27,26.91,6.63,78,5.24,132.51C1056.43,1193.4,1040.88,1207.16,1022.11,1207.16Zm-8.06-181.62h-.46c-25.69.32-71.78,4.25-108.82,7.4-17.66,1.51-34.34,2.93-46.24,3.74h0a21.29,21.29,0,0,0-14.84,7.22,16.13,16.13,0,0,0-3.86,12.13l12.35,117.89c1.4,13.29,13.92,23.42,29.14,23.57l140.51,1.35h.28c14.29,0,26.12-10.13,26.44-22.71,1.38-53.83,2-104.29-5-130.13C1040.32,1033.91,1028.21,1025.54,1014.05,1025.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M873.73,1050.08c29.52-2,93.67-8.53,124.1-8.91,12.89-.16,24.2,7.63,27.23,18.81,5.87,21.71,5.09,65,4.07,104.94-.3,12-11.29,21.52-24.71,21.39l-112.29-1.08c-13.8-.13-25.27-9.55-26.55-21.81l-9.87-94.21C854.68,1059.46,862.79,1050.83,873.73,1050.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1140.32,1086.23c-3.52-.06-5.41,2.59-4.22,5.89l21.05,58.21a9.77,9.77,0,0,0,8.56,6H2154.5a6.18,6.18,0,0,0,6.2-6.38l-1.19-39.65a6.79,6.79,0,0,0-6.58-6.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M879.71,1068.57h0a21.57,21.57,0,0,1,29.75,8.09l27.71,49.69a6.93,6.93,0,0,0,12.37-.54l68.74-153c3.43-7.63,14.8-5,14.67,3.32-.7,46.81-13.12,135.79-87.92,210.27,0,0-41.21-16-74.41-88.91A22.63,22.63,0,0,1,879.71,1068.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022.12,1508.31h-.37L881.24,1507c-19.45-.19-35.5-13.52-37.33-31l-12.36-117.89a24.41,24.41,0,0,1,5.77-18.35A29.62,29.62,0,0,1,858,1329.53h0c11.86-.81,28.55-2.23,46.22-3.74,37.13-3.16,83.34-7.09,109.31-7.42h.55c17.92,0,33.33,10.88,37.59,26.62,7.27,26.9,6.63,78,5.24,132.51C1056.43,1494.56,1040.88,1508.31,1022.12,1508.31ZM858.53,1337.83a21.26,21.26,0,0,0-14.84,7.23,16.11,16.11,0,0,0-3.86,12.12l12.35,117.89c1.4,13.3,13.92,23.43,29.14,23.57l140.51,1.35h.29c14.28,0,26.11-10.13,26.43-22.71,1.38-53.83,2-104.29-5-130.12-3.31-12.23-15.53-20.82-30-20.47-25.66.32-71.7,4.24-108.7,7.4-17.71,1.5-34.44,2.93-46.36,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M873.73,1351.23c29.52-2,93.67-8.53,124.1-8.91,12.89-.16,24.2,7.63,27.23,18.81,5.87,21.72,5.09,65,4.07,104.94-.3,12-11.29,21.52-24.71,21.39l-112.29-1.08c-13.8-.13-25.27-9.55-26.55-21.81l-9.87-94.21C854.68,1360.61,862.79,1352,873.73,1351.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1140.32,1387.38c-3.52-.06-5.41,2.59-4.22,5.89l21.05,58.21a9.77,9.77,0,0,0,8.56,6H2154.5a6.18,6.18,0,0,0,6.2-6.38l-1.19-39.65a6.78,6.78,0,0,0-6.58-6.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M879.71,1369.72h0a21.56,21.56,0,0,1,29.75,8.1l27.71,49.68a6.93,6.93,0,0,0,12.37-.54l68.74-153c3.43-7.63,14.8-5.05,14.67,3.32-.7,46.81-13.12,135.79-87.92,210.27,0,0-41.21-16-74.41-88.91A22.63,22.63,0,0,1,879.71,1369.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022.12,1809.46h-.37l-140.51-1.35c-19.45-.19-35.5-13.52-37.33-31L831.55,1659.2a24.41,24.41,0,0,1,5.77-18.35A29.62,29.62,0,0,1,858,1630.68h0c11.86-.81,28.55-2.23,46.22-3.73,37.13-3.16,83.34-7.1,109.31-7.43h.55c17.92,0,33.33,10.88,37.59,26.62,7.27,26.91,6.63,78,5.24,132.51C1056.43,1795.71,1040.88,1809.46,1022.12,1809.46ZM858.53,1639a21.21,21.21,0,0,0-14.84,7.22,16.11,16.11,0,0,0-3.86,12.12l12.35,117.9c1.4,13.29,13.92,23.42,29.14,23.56l140.51,1.35h.29c14.28,0,26.11-10.13,26.43-22.71,1.38-53.83,2-104.29-5-130.12-3.31-12.23-15.53-20.74-30-20.47-25.66.32-71.7,4.24-108.7,7.4-17.71,1.5-34.44,2.93-46.36,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M873.73,1652.39c29.52-2,93.67-8.54,124.1-8.91,12.89-.16,24.2,7.62,27.23,18.8,5.87,21.72,5.09,65,4.07,105-.3,12-11.29,21.51-24.71,21.38l-112.29-1.08c-13.8-.13-25.27-9.55-26.55-21.81l-9.87-94.21C854.68,1661.76,862.79,1653.13,873.73,1652.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1140.32,1688.53c-3.52-.06-5.4,2.59-4.19,5.88l21.38,58.23a9.83,9.83,0,0,0,8.58,6h1004a6.17,6.17,0,0,0,6.19-6.38l-1.21-39.65a6.79,6.79,0,0,0-6.58-6.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M879.71,1670.87h0a21.57,21.57,0,0,1,29.75,8.1l27.71,49.68a6.93,6.93,0,0,0,12.37-.54l68.74-153c3.43-7.63,14.8-5,14.67,3.32-.7,46.81-13.12,135.79-87.92,210.27,0,0-41.21-16-74.41-88.91A22.63,22.63,0,0,1,879.71,1670.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022.12,2110.61h-.37l-140.51-1.35c-19.45-.18-35.5-13.52-37.33-31l-12.36-117.9a24.41,24.41,0,0,1,5.77-18.35A29.59,29.59,0,0,1,858,1931.84h0c11.83-.81,28.48-2.23,46.1-3.73,37.17-3.17,83.43-7.11,109.43-7.43h.56c17.91,0,33.32,10.88,37.58,26.61,7.27,26.91,6.63,78,5.24,132.51C1056.43,2096.86,1040.88,2110.61,1022.12,2110.61ZM1014.05,1929h-.46c-25.69.31-71.79,4.24-108.82,7.4-17.66,1.5-34.34,2.92-46.24,3.74h0a21.21,21.21,0,0,0-14.84,7.22,16.11,16.11,0,0,0-3.86,12.12l12.35,117.9c1.4,13.29,13.92,23.42,29.14,23.56l140.51,1.35h.29c14.28,0,26.11-10.13,26.43-22.7,1.38-53.84,2-104.3-5-130.13C1040.32,1937.36,1028.21,1929,1014.05,1929Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M873.73,1953.54c29.52-2,93.67-8.53,124.1-8.91,12.89-.16,24.2,7.63,27.23,18.81,5.87,21.71,5.09,65,4.07,104.94-.3,12-11.29,21.51-24.71,21.38l-112.29-1.08c-13.8-.13-25.27-9.54-26.55-21.81l-9.87-94.21C854.68,1962.92,862.79,1954.29,873.73,1953.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1140.32,1989.68c-3.52-.06-5.37,2.58-4.13,5.86l22,58.27a10,10,0,0,0,8.64,6H2200.67a6.17,6.17,0,0,0,6.18-6.39l-1.24-39.65a6.79,6.79,0,0,0-6.59-6.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M879.71,1972h0a21.56,21.56,0,0,1,29.75,8.09l27.71,49.68a6.93,6.93,0,0,0,12.37-.54l68.74-153c3.43-7.64,14.8-5.06,14.67,3.31-.7,46.81-13.12,135.79-87.92,210.27,0,0-41.21-16-74.41-88.91A22.61,22.61,0,0,1,879.71,1972Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1039,2411h-.37l-140.51-1.35c-19.45-.19-35.5-13.52-37.33-31l-12.36-117.89a24.4,24.4,0,0,1,5.77-18.35,29.64,29.64,0,0,1,20.64-10.17h0c11.83-.81,28.47-2.22,46.1-3.73,37.17-3.16,83.43-7.1,109.43-7.43h.56c17.91,0,33.32,10.88,37.57,26.61,7.28,26.91,6.64,78,5.25,132.51C1073.26,2397.24,1057.71,2411,1039,2411Zm-8.07-181.62h-.46c-25.69.32-71.79,4.25-108.83,7.4-17.66,1.51-34.33,2.93-46.23,3.75h0a21.24,21.24,0,0,0-14.84,7.21,16.13,16.13,0,0,0-3.86,12.13L869,2377.76c1.39,13.29,13.92,23.42,29.14,23.57l140.51,1.35h.29c14.28,0,26.11-10.13,26.43-22.71,1.37-53.84,2-104.3-5-130.13C1057.15,2237.75,1045,2229.38,1030.88,2229.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M890.56,2253.92c29.52-2,93.67-8.53,124.1-8.91,12.89-.16,24.2,7.63,27.22,18.81,5.88,21.71,5.1,65,4.08,104.94-.31,12-11.29,21.52-24.71,21.39L909,2389.07c-13.81-.13-25.27-9.55-26.55-21.81l-9.88-94.21C871.51,2263.3,879.62,2254.67,890.56,2253.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1163.74,2290.06c-3.51-.06-5.37,2.58-4.13,5.87l22,58.27a9.94,9.94,0,0,0,8.63,6H2222.3a6.17,6.17,0,0,0,6.19-6.38l-1.24-39.65a6.8,6.8,0,0,0-6.59-6.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M896.54,2272.41h0a21.57,21.57,0,0,1,29.75,8.09L954,2330.19a6.93,6.93,0,0,0,12.37-.54l68.74-153c3.43-7.63,14.8-5.05,14.67,3.32-.7,46.81-13.12,135.79-87.92,210.27,0,0-41.21-16-74.41-88.91A22.63,22.63,0,0,1,896.54,2272.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M947.28,854.92l-26.64.61a11.65,11.65,0,0,1-7.42-2.07,12.78,12.78,0,0,1-4.29-5.48l-14.69-37.46-76.73,1.75-13,38.1a12.06,12.06,0,0,1-3.91,5.47,11.29,11.29,0,0,1-7.31,2.6l-26.76.61,68.51-186.87,35.22-.8ZM825.8,787.73l59-1.35-24-61.09q-1.64-4.06-3.61-9.59t-3.93-12q-1.65,6.58-3.25,12.25t-3.16,9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1000.48,788.48l1.49,65.19-34.46.79-4.23-185.21,60.33-1.38q18.57-.42,32.24,3.63t22.7,11.65a47.63,47.63,0,0,1,13.49,18.4,69.69,69.69,0,0,1,.85,48.49,51.15,51.15,0,0,1-13,19.58,62.48,62.48,0,0,1-22.12,13.06q-13.35,4.8-31.41,5.21Zm-.62-26.9,25.88-.59a51.7,51.7,0,0,0,16.46-2.75,30.5,30.5,0,0,0,11.5-7,27.85,27.85,0,0,0,6.67-10.92,41.16,41.16,0,0,0,2-14.2,37.52,37.52,0,0,0-2.62-13.4,26.49,26.49,0,0,0-7.15-10.09,30.78,30.78,0,0,0-11.8-6.2,54.41,54.41,0,0,0-16.57-1.86l-25.88.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1160.58,784.82l1.49,65.19-34.45.79-4.24-185.21,60.33-1.38q18.57-.42,32.25,3.63t22.69,11.65a47.63,47.63,0,0,1,13.49,18.4,65,65,0,0,1,4.77,23.73,65.71,65.71,0,0,1-3.92,24.76A51.13,51.13,0,0,1,1240,766,62.53,62.53,0,0,1,1217.86,779q-13.35,4.8-31.41,5.21Zm-.61-26.9,25.87-.59a51.71,51.71,0,0,0,16.47-2.75,30.58,30.58,0,0,0,11.5-7.05,28,28,0,0,0,6.67-10.92,41.17,41.17,0,0,0,2-14.2,37.3,37.3,0,0,0-2.61-13.4,26.71,26.71,0,0,0-7.15-10.09,30.83,30.83,0,0,0-11.81-6.2,54.37,54.37,0,0,0-16.57-1.86l-25.87.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1320.52,774l1.65,72.36-34.45.79-4.23-185.21,56.48-1.29q19-.43,32.56,3.17t22.41,10.44A42.29,42.29,0,0,1,1408,690.81a59,59,0,0,1,2.18,39.22,51.29,51.29,0,0,1-7.59,15.3,53.74,53.74,0,0,1-12.54,12.2,67.32,67.32,0,0,1-17.17,8.6,34.13,34.13,0,0,1,11.52,10.37l47.93,67.34-31,.7a15.09,15.09,0,0,1-7.66-1.62,15.56,15.56,0,0,1-5.44-5l-40.29-58.41a13.64,13.64,0,0,0-4.91-4.63c-1.77-.9-4.37-1.31-7.78-1.23Zm-.57-24.72,21.52-.49a53.21,53.21,0,0,0,16.92-2.83,32.94,32.94,0,0,0,11.76-7,26.93,26.93,0,0,0,6.74-10.34,35.17,35.17,0,0,0,2-13q-.32-14.08-9.78-21.43t-28.54-6.91l-22,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1623.74,746.81a102.69,102.69,0,0,1-5.92,37.87,89.36,89.36,0,0,1-18.4,30.47,86.32,86.32,0,0,1-29.13,20.47,107,107,0,0,1-76.66,1.75,86.81,86.81,0,0,1-30.17-19.11,88.9,88.9,0,0,1-19.83-29.59,108.3,108.3,0,0,1-1.73-75.45,88.81,88.81,0,0,1,18.46-30.47,87.14,87.14,0,0,1,29.26-20.47,100.44,100.44,0,0,1,38.2-8,99.16,99.16,0,0,1,38.46,6.29,87.59,87.59,0,0,1,30,19.12,88.69,88.69,0,0,1,19.77,29.53A102.7,102.7,0,0,1,1623.74,746.81Zm-35.35.8a86.08,86.08,0,0,0-4.66-27.25,57.8,57.8,0,0,0-12.06-20.29A50,50,0,0,0,1553,687.55a68.9,68.9,0,0,0-48.87,1.12A50.45,50.45,0,0,0,1485.92,702a58.12,58.12,0,0,0-11.25,20.82,93.41,93.41,0,0,0,1.25,54.7,57.43,57.43,0,0,0,12.19,20.22,50.73,50.73,0,0,0,18.8,12.45,68.86,68.86,0,0,0,48.86-1.12,50.19,50.19,0,0,0,18.09-13.29A57.14,57.14,0,0,0,1585,775.05,85.89,85.89,0,0,0,1588.39,747.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1623.42,654.16l27.79-.63a11.63,11.63,0,0,1,7.36,2,13.29,13.29,0,0,1,4.35,5.54l46.13,112q2.31,5.46,4.44,12t4.1,13.81a159.37,159.37,0,0,1,6.7-26.17l40.84-114a13.26,13.26,0,0,1,4-5.47,11,11,0,0,1,7.24-2.6l27.8-.64L1733.58,837l-31.12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1940.3,646.92l.62,27.41-82.1,1.88,1.17,51.36,64.68-1.48.61,26.51-64.68,1.48,1.2,52.39,82.1-1.88.63,27.54-116.81,2.67-4.24-185.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2136.71,735.08a100.32,100.32,0,0,1-5.93,37.56,84,84,0,0,1-47.57,49.52,104,104,0,0,1-38.14,7.67l-70.7,1.61-4.23-185.2,70.7-1.62a103,103,0,0,1,38.45,6,86.63,86.63,0,0,1,30,18.4,85.35,85.35,0,0,1,19.76,28.84A100.22,100.22,0,0,1,2136.71,735.08Zm-35.22.81a85.22,85.22,0,0,0-4.72-27.26,58,58,0,0,0-12.13-20.22A50.38,50.38,0,0,0,2066,676a63.33,63.33,0,0,0-24.51-3.92l-36,.82,3,130.39,36-.82a63.41,63.41,0,0,0,24.3-5,50.42,50.42,0,0,0,18.09-13.29A58,58,0,0,0,2098,763.33,85.35,85.35,0,0,0,2101.49,735.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2159.14,718.42a19.67,19.67,0,0,1,1.3-7.59,18.17,18.17,0,0,1,4-6.24,20.11,20.11,0,0,1,6.12-4.24,19.7,19.7,0,0,1,15.24-.35,18.87,18.87,0,0,1,10.48,10,19.53,19.53,0,0,1,.35,15.18,20,20,0,0,1-4,6.18,18.4,18.4,0,0,1-6.06,4.17,19.65,19.65,0,0,1-7.52,1.65,20,20,0,0,1-7.72-1.3A18.93,18.93,0,0,1,2165,732a18.11,18.11,0,0,1-4.24-6A19.44,19.44,0,0,1,2159.14,718.42Zm2.09,91.32a19.7,19.7,0,0,1,1.3-7.59,17.88,17.88,0,0,1,4-6.24,20.36,20.36,0,0,1,6.11-4.24,19.28,19.28,0,0,1,7.66-1.71,19,19,0,0,1,7.59,1.36,18.85,18.85,0,0,1,10.48,10,19.45,19.45,0,0,1,.34,15.17,19.38,19.38,0,0,1-4,6.18,18.53,18.53,0,0,1-6.05,4.18,20.47,20.47,0,0,1-15.24.34,19.08,19.08,0,0,1-6.31-3.89,18,18,0,0,1-4.23-6A19.4,19.4,0,0,1,2161.23,809.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1611.44,39.37C1552.89-1.36,1502-.55,1466.15,10a71.49,71.49,0,0,0-50.77,75.15l15.46,168.68,183.9,16.32S1726.25,119.25,1611.44,39.37Zm-80.87,136.08a45.86,45.86,0,1,1,45.85-45.85A45.85,45.85,0,0,1,1530.57,175.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1449.21,182.62a4.17,4.17,0,0,1-4.14-3.78L1442.61,152a4.16,4.16,0,1,1,8.28-.75l2.46,26.86a4.16,4.16,0,0,1-3.76,4.52ZM1444.38,130a4.15,4.15,0,0,1-4.13-3.78l-1.87-20.39a68,68,0,0,1,48.17-71.3,137.2,137.2,0,0,1,67.08-2.75,4.15,4.15,0,1,1-1.67,8.14,129.1,129.1,0,0,0-63,2.59A59.61,59.61,0,0,0,1446.66,105l1.87,20.39a4.15,4.15,0,0,1-3.76,4.52A2.55,2.55,0,0,1,1444.38,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1179.85,362.86v-84.8a51.75,51.75,0,0,1,53.52-51.73l584.72,20a50.34,50.34,0,0,1,48.52,47.29l4.88,81.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1397.87,258h-25.14a4.16,4.16,0,0,1,0-8.32h25.14a4.16,4.16,0,1,1,0,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1211.5,336a4.16,4.16,0,0,1-4.16-4.16V297.49a47.85,47.85,0,0,1,47.79-47.8h92.45a4.16,4.16,0,1,1,0,8.32h-92.45a39.52,39.52,0,0,0-39.47,39.48V331.8A4.17,4.17,0,0,1,1211.5,336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M996.63,331.82l1022.49,0a75.57,75.57,0,0,1,74.47,62.68l.87,5a64.9,64.9,0,0,1-64,76h-1049a42.2,42.2,0,0,1-42.15-44.22l2.26-47A55.11,55.11,0,0,1,996.63,331.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2637.36,2754.74a111.09,111.09,0,0,0,113.21-111.08V2149.33a118.43,118.43,0,0,0-117.14-118.5c-194.91-2.13-596.91-2.23-925.83,25.49a89,89,0,0,0-81.43,85.58l-30.74,477.92a113.16,113.16,0,0,0,110.94,117.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2637.68,2202.81c.83,42.07-.42,108.81-1.44,151.92a38.08,38.08,0,0,1-42.52,36.92l-160.4-18.8a38.09,38.09,0,0,1-33.24-43.48L2419.77,2198a38.1,38.1,0,0,1,37.67-32.44H2599.6A38,38,0,0,1,2637.68,2202.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2218.48,2451.74l-133.81,14.43a30.16,30.16,0,0,1-33.32-32.2l29.26-398c56.09-1.78,111.42-3.08,164.8-4v389.8A30.17,30.17,0,0,1,2218.48,2451.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2163.64,2382.75a13.46,13.46,0,0,1-13.43,12.68q-.39,0-.78,0a13.44,13.44,0,0,1-12.66-14.21l20.18-347.4c9.05-.22,18-.42,27-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2563.5,2328.2a4.49,4.49,0,0,0,4.48-4.2l6.94-109.42a4.49,4.49,0,0,0-4.2-4.76,4.39,4.39,0,0,0-4.76,4.2L2559,2323.44a4.47,4.47,0,0,0,4.2,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2549.21,2328.2a4.49,4.49,0,0,0,4.49-4.34l3.64-111.51a4.5,4.5,0,0,0-4.34-4.64,4.25,4.25,0,0,0-4.64,4.34l-3.63,111.52a4.49,4.49,0,0,0,4.34,4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2529.85,2328.19a4.47,4.47,0,0,1-4.27-4.68c1.78-37.47,5.17-108.92,5.22-111.35a4.49,4.49,0,0,1,9,0c0,1.85-4.37,93.39-5.24,111.73a4.48,4.48,0,0,1-4.48,4.27Zm.87-116h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2500.15,2332.69a9,9,0,0,0,9-8.66c3.79-108,3.13-110.48,2.69-112.09a9,9,0,0,0-17.55,3.55c.28,6.49-1.72,69.35-3.07,107.91a9,9,0,0,0,8.65,9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2480.71,2328.2a4.47,4.47,0,0,0,4.48-4.48V2214.3a4.49,4.49,0,1,0-9,0v109.42A4.48,4.48,0,0,0,2480.71,2328.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2465,2328.2a4.48,4.48,0,0,0,4.49-4.38c.86-38,2.87-100.12,4.66-107.59a4.49,4.49,0,0,0-6.38-5.94c-2.44,1.6-4.76,3.12-7.25,113.32a4.5,4.5,0,0,0,4.38,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2587.64,2338.17a9,9,0,0,0,9-8.51l6-114.9a9,9,0,0,0-8.5-9.43,9.08,9.08,0,0,0-9.43,8.5l-6,114.9a9,9,0,0,0,8.5,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2175,2675.38V2328.22c0-45.61-31.68-82.73-71.1-83.22-118.3-1.5-362.28-1.57-561.91,17.9-27.24,2.65-48.43,28.49-49.42,60.1l-18.66,335.63c-1.39,44.4,28.95,81.49,67.33,82.33l565.05,12.42C2144,2754.21,2175,2719.05,2175,2675.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2106.48,2365.78c.5,29.54-.26,76.41-.88,106.69-.32,15.75-12.27,27.76-25.8,25.92l-97.35-13.2c-13-1.76-22.11-15.59-20.18-30.53l12-92.25c1.7-13.09,11.42-22.78,22.87-22.78h86.28C2095.94,2339.63,2106.23,2351.23,2106.48,2365.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1852.06,2540.59l-81.22,10.14c-11.36,1.42-21.06-9.43-20.22-22.62l17.76-279.53c34-1.25,67.62-2.16,100-2.8v273.75C1868.4,2530.35,1861.36,2539.43,1852.06,2540.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1818.77,2492.14c-.25,5-3.85,8.91-8.15,8.91l-.48,0c-4.5-.3-7.94-4.77-7.67-10l12.24-244c5.49-.16,10.94-.3,16.38-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2061.46,2453.83a2.92,2.92,0,0,0,2.71-2.95l4.22-76.84a3,3,0,0,0-2.55-3.34,2.83,2.83,0,0,0-2.89,2.94l-4.21,76.85a3,3,0,0,0,2.55,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2052.79,2453.83a2.94,2.94,0,0,0,2.72-3l2.21-78.32a3,3,0,0,0-2.64-3.25c-1.73-.1-2.76,1.31-2.81,3.05l-2.21,78.31a3,3,0,0,0,2.64,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2041,2453.83a3,3,0,0,1-2.59-3.29c1.08-26.31,3.14-76.49,3.17-78.2a2.75,2.75,0,1,1,5.45,0c0,1.3-2.65,65.59-3.18,78.46a2.93,2.93,0,0,1-2.72,3Zm.53-81.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2023,2457c2.92,0,5.33-2.68,5.44-6.08,2.3-75.88,1.89-77.59,1.63-78.72-.79-3.37-3.81-5.35-6.69-4.43-2.66.84-4.33,3.83-4,6.92.17,4.56-1,48.7-1.87,75.78-.1,3.48,2.25,6.4,5.25,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2011.21,2453.83a3,3,0,0,0,2.72-3.15v-76.84a2.75,2.75,0,1,0-5.44,0v76.84A3,3,0,0,0,2011.21,2453.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2001.68,2453.83a2.94,2.94,0,0,0,2.72-3.07c.52-26.7,1.74-70.32,2.83-75.56a3.6,3.6,0,0,0-.1-3.27,2.5,2.5,0,0,0-3.77-.9c-1.49,1.12-2.89,2.19-4.41,79.58a3,3,0,0,0,2.66,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2076.11,2460.83c2.88,0,5.28-2.61,5.43-6l3.64-80.69c.15-3.48-2.16-6.44-5.16-6.63-2.85-.23-5.57,2.5-5.73,6l-3.63,80.69c-.15,3.48,2.16,6.44,5.16,6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1534.8,1904.93,864.9,2634.06a71.23,71.23,0,0,0,8.48,104.24l5.36,4.21A66.23,66.23,0,0,0,972,2731l609.42-787.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1906.25,
    cy: 1501.31,
    rx: 542.04,
    ry: 532.26,
    transform: "translate(-477.25 1046.75) rotate(-27.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1633.46,975.61c-295.67,153.42-413.22,513.16-262.57,803.49S1883.36,2180.43,2179,2027s413.23-513.16,262.58-803.5S1929.13,822.18,1633.46,975.61ZM2139,1949.79c-252.24,130.88-560.91,36.2-689.43-211.49s-28.23-554.59,224-685.47,560.91-36.2,689.44,211.49S2391.2,1818.9,2139,1949.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1443.73,1821a1.54,1.54,0,0,1-1.48-.65c-8-11.57-15.68-23.62-22.79-35.8a1.55,1.55,0,1,1,2.67-1.56c7.07,12.12,14.7,24.1,22.66,35.6a1.54,1.54,0,0,1-1.06,2.41Zm-72.6-148.9a1.55,1.55,0,0,1-1.69-1.08,542.85,542.85,0,0,1-22.31-113.3c-9.55-108.76,13.38-217.6,66.32-314.77,54.2-99.49,136.52-179.93,238.06-232.61,95.49-49.55,202.08-71.2,308.26-62.59a1.55,1.55,0,0,1-.25,3.08,566,566,0,0,0-306.59,62.25c-101,52.4-182.86,132.4-236.77,231.35-52.64,96.63-75.45,204.87-66,313a540.08,540.08,0,0,0,22.18,112.66,1.54,1.54,0,0,1-1,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M935.22,2732.55c-29.12,4.06-49.38-3.47-60.26-22.38-11.07-19.25-8.17-44,7.23-61.5l79.1-90.12a1.3,1.3,0,1,1,2,1.72l-79.09,90.13c-14.66,16.69-17.44,40.19-6.93,58.47,10.4,18.08,30,25.16,58.53,21h0a1.31,1.31,0,1,1,.37,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M986.82,2532.94a1.31,1.31,0,0,1-1.16-2.16l10.25-11.69a1.31,1.31,0,0,1,2,1.73l-10.25,11.68A1.36,1.36,0,0,1,986.82,2532.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M666.82,1572.77s0,182.19-79.88,167.33c-48.8-9.07-77.69-205.33-77.69-205.33s50.49-112.47,56.13-75.66C606.37,1726.73,636.9,1521.9,666.82,1572.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M452.29,2654.17s-6,34.14-9,67.94a23.28,23.28,0,0,0,22.27,25.23c45,1.88,141.29,5.52,175.84,4a7.58,7.58,0,0,0,6.67-10.38h0a17,17,0,0,0-8.68-9.14l-159-73.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M447.35,2634.11,452.2,2675s27.86,13,46.88-1.64l-11.53-45.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M451,1866.29c-2.1,10.67-11.24,532.22,44.51,765.95a7.93,7.93,0,0,1-4.65,9.23,138.39,138.39,0,0,1-45.41,9.23,13.66,13.66,0,0,1-13.55-9.81C416,2586.66,339.6,2315,329.64,2055.41c-11.13-290,0-9.87,0-9.87l6.53-179.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M269.35,2672s-9.6,17.24-18.89,63a14.21,14.21,0,0,0,12.5,17c14.86,1.46,37.74,3.34,56.07,3.21a14.16,14.16,0,0,0,14-15.8c-2-16.72-8.35-44.15-27.89-65.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M260.92,2619.45l11.32,61.76s11.2,8.33,33.34,2.29l-5.4-66.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M230.33,1882.29c-45.59,275.18,9.89,680.13,28.61,759.39a12.34,12.34,0,0,0,10,9.38c8.35,1.39,22.1,2.52,35.66-1.42a11.34,11.34,0,0,0,8.15-10.43c2.51-64.08-2-457.45,40.47-612.92a35.36,35.36,0,0,1,13.62-19.48l82.47-58.62,6.32-94.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M525.9,1371.28c-166.49-16.65-292.44,25.48-292.44,25.48-40.73,237.67-7.12,511.79-7.12,511.79,105.78,27.75,225.12-17,225.12-17,17.58-99.33,90.84-328.71,90.84-328.71,33.38-4.15,64.71,12.72,57.51-33.62S546.87,1373.38,525.9,1371.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M285.87,1529.08l-52.41-132.32s-127.63,86.72-148.62,196.68c24.11,1.77,68,8,111,29.74C205.23,1571.26,285.87,1529.08,285.87,1529.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M408.51,1653.58s-147.43,80.76-195.78,11.61c-10-14.36-19.07-33.42-16.6-47-42.95-21.69-87.18-23-111.29-24.72-6.33,33.15-3.09,61.3,21.11,106.6,64.73,121.16,321.52-11.13,321.52-11.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M415.19,1706.63l62.63-218.72a6.38,6.38,0,0,1,5.39-4.6c11.35-1.32,44.23-5,82.19-8.25,45.73-3.87,98.84-7,130.57-4.34a6.4,6.4,0,0,1,5.23,9.21c-18,36.51-92.27,185-129.44,233.67a6.4,6.4,0,0,1-5.17,2.54l-145.31-1.35A6.4,6.4,0,0,1,415.19,1706.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M574.25,1456.34l44.59-7.42a3.19,3.19,0,0,1,3.56,4.15L618,1466.45a3.21,3.21,0,0,1-2.62,2.17l-42.91,5.73a3.2,3.2,0,0,1-3.54-3.9l2.74-11.68A3.2,3.2,0,0,1,574.25,1456.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M540.86,1494.09l3.67-19.13a4.44,4.44,0,0,1,3.9-3.57l90.06-9.14a4.43,4.43,0,0,1,4.75,5.44l-5.73,23.84a4.42,4.42,0,0,1-4.08,3.38l-88,4.43A4.42,4.42,0,0,1,540.86,1494.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M421.27,1690.36a12.44,12.44,0,0,1-13.23-10c-2.92-14.08-7.46-39.8-4.36-51,4.4-15.9,12.91-36.33,41.3-31.79s61.86,16.5,61.86,16.5-1.7,20.7-23.27,14L497,1638.44s-1.91,16.57-20.13,7.72l12.44,13.72s-7.83,13.62-21.23,4.89C456.05,1657,449.64,1687.62,421.27,1690.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M629.07,1620.73s33-32.16,37.75-48,8.36-37.64-18.1-48.87S587.55,1505,587.55,1505s-9.57,18.44,12.26,24.24L583,1530.92s-7.19,15.06,12.95,17.23l-17.83,5s-.6,15.69,15.39,15.42S594,1605.11,629.07,1620.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M388.52,1266.92,345,1392.66a4.53,4.53,0,0,0,2.06,5.46c11.85,6.55,54.55,25.49,106-7.14a21.3,21.3,0,0,0,9.82-15.23L477,1266.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M518.34,1235.81s-14.05,100.79-40.3,126.6-72.64-11-97.19-65.19l27.67-99.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M410.65,1260a3.71,3.71,0,0,0,4.49-3.44c.33-7,1.51-20.84,5.78-30.63,0,0-3.72-9.49,25.19,2.46s72.3,29.41,95.21,14c22.35-15,39.81-80.76-21.44-62.65a3.71,3.71,0,0,1-4.78-3.41c-.3-10.48-3.78-34.32-28.8-39.52-23.43-4.87-34.8,6.64-39.29,13.34a3.67,3.67,0,0,1-5.74.5c-7.7-8.18-28.09-25.18-54-10.43-21.37,12.16-23.44,26.3-22.19,34.85a3.7,3.7,0,0,1-4.88,4c-7.18-2.46-18.37-3-27.58,11.34-12.72,19.79,9.76,33.52,16.44,37a3.72,3.72,0,0,1,2,2.88c1,9.5,6.75,50.85,29.94,72.13a3.74,3.74,0,0,0,6.07-1.7L399.13,1261a3.73,3.73,0,0,1,4.34-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M411.78,1267.67s-13.85-38.83-27.38-24.38,8.1,41,25.67,44.68Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityAssurance2);
export default __webpack_public_path__ + "static/media/quality_assurance_2.004472275ae4ec1d6931477511354507.svg";
export { ForwardRef as ReactComponent };